module.exports = __webpack_public_path__ + "static/media/logo.2f25a5a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.png
// module id = 107
// module chunks = 4